import React, {useEffect, useState} from 'react'
import {makeStyles} from '@material-ui/core/styles';
import {Grid} from '@material-ui/core';
import {blue, green, pink, teal} from "@material-ui/core/colors";
import {getOrganizations} from "../../api/organization-functions";
import OrganizationCard from "./organization/OrganizationCard";
import {useApiNotification} from "../ui/ApiNotificationProvider";
import {run} from "../../utils/function-util";
import {useCapability} from "../../auth/CapabilityContext";

const CardHeaderColors = [blue[700], teal[500], green[400], pink[900], blue[900], green[300]];
const useStyles = makeStyles(theme => ({
    container: {
        marginTop: theme.spacing(4),

        '& > *': {
            margin: theme.spacing(2)
        }
    }
}));


function OrganizationsCardPicker({onSelect, ...props}: any) {
    const classes = useStyles();
    const {capabilities, setCapabilities} = useCapability();
    const [organizations, setOrganizations] = useState([]);
    const {handleError} = useApiNotification();

    useEffect(run(
        async () => await getOrganizations(),
        (allOrganizations: any) => {
            initOrganizations(allOrganizations);
            if (allOrganizations.length == 1) {
                void selectOrganization(allOrganizations[0]);
            }
        },
        handleError
    ), []);

    const initOrganizations = (organizationsToInit: any) => {
        setOrganizations(organizationsToInit);
        const initCapabilities = organizationsToInit.reduce((acc: any, curr: any) => ({
            ...acc,
            [curr.id]: capabilities[curr.id] ?? {}
        }), {});
        setCapabilities(initCapabilities);
    }

    const selectOrganization = async (organization: any) => {
        onSelect(organization);
    };

    if (!organizations || !organizations.length)
        return null;

    return <Grid container item justify="center" className={classes.container}>
        {
            organizations.length > 1 ?
                organizations.map((o: any, i) =>
                    <Grid item key={o.name}>
                        <OrganizationCard key={o.name}
                                          organization={o}
                                          {...props}
                                          variant={CardHeaderColors[i % CardHeaderColors.length]}
                                          onSelect={selectOrganization}/>
                    </Grid>) :
                null
        }
    </Grid>;
}

export default OrganizationsCardPicker
